import { TESSearchField, TESSearchFields } from '../definitions';
import { TMgravisESSearchFields } from '../definitions/mgravis';

export const mgravisExtendedSearchFields = (searchFields?: TESSearchFields): TESSearchField[] => [
  {
    name: 'gender',
    type: 'Radio',
    options: ['male', 'female'],
  },
  {
    name: 'age',
    type: 'RangeSlider',
    min: 0,
    max: 100,
    showRangeText: true,
    marks: [{ value: 33 }, { value: 66 }],
  },
  {
    name: 'diagnosis',
    type: 'Checkbox',
    options: ['G70.0', 'G73.1'],
    optionFormatter: (name: string | number): string | React.JSX.Element => `${name}`,
  },
  {
    name: 'diagnosisDate',
    type: 'Custom',
  },
  {
    name: 'serologicalProfile',
    type: 'Custom',
  },
  {
    name: 'medication',
    type: 'Custom',
  },
  {
    name: 'substance',
    type: 'Custom',
  },
  {
    name: 'plasmaChangeDone',
    type: 'Radio',
    options: ['yes', 'no'],
  },
  {
    name: 'thymectomyDone',
    type: 'Radio',
    options: ['yes', 'no'],
  },
  {
    name: 'hospitalWardDuringLast12Months',
    type: 'Radio',
    options: ['yes', 'no'],
  },
  {
    name: 'intensiveCareDuringLast12Months',
    type: 'Radio',
    options: ['yes', 'no'],
  },
  {
    name: 'latestMgcScore',
    type: 'RangeSlider',
    min: 0,
    max: 50,
    showRangeText: true,
    marks: [{ value: 16.67 }, { value: 33.34 }],
  },
  {
    name: 'latestHcpReportedMgadlScore',
    type: 'RangeSlider',
    min: 0,
    max: 24,
    showRangeText: true,
    marks: [{ value: 8 }, { value: 16 }],
  },
  {
    name: 'latestPatientReportedMgadlScore',
    type: 'RangeSlider',
    min: 0,
    max: 24,
    showRangeText: true,
    marks: [{ value: 8 }, { value: 16 }],
  },
  {
    name: 'myServiceInUse',
    type: 'Radio',
    options: ['yes', 'no'],
  },
  {
    name: 'includeDeceased',
    type: 'Radio',
    options: ['yes', 'no'],
  },
];

export const defaultMgravisSearchValues: TMgravisESSearchFields = {
  serologicalProfile: 'noCropping',
  plasmaChangeDone: 'noCropping',
  thymectomyDone: 'noCropping',
  hospitalWardDuringLast12Months: 'noCropping',
  intensiveCareDuringLast12Months: 'noCropping',
  latestMgcScore: 'noCropping',
  latestHcpReportedMgadlScore: 'noCropping',
  latestPatientReportedMgadlScore: 'noCropping',
};

export const serologicalProfileFieldToUnitMap = new Map([
  ['S-AChR-Ab', 'nmol/l'],
  ['S-MuSKAb', 'U/ml'],
]);
